import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useA11yStore = defineStore('a11y', () => {
  const message = ref('')

  function announce(newMessage) {
    message.value = ''
    requestAnimationFrame(() => {
      message.value = newMessage
    })
  }

  return {
    message,
    announce,
  }
})
